"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
require("core-js/modules/es6.number.constructor.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
require("core-js/modules/es6.array.slice.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _icons = _interopRequireDefault(require("./icons"));
var _excluded = ["size"];
var _jsxFileName = "/codebuild/output/src6272852/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Icon/lib/index.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_224iz9o3ou() {
  var path = "/codebuild/output/src6272852/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Icon/lib/index.js";
  var hash = "5b0ce4958c26b78db2ea2d74d824d5e5fd821e64";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src6272852/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Icon/lib/index.js",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 17
        },
        end: {
          line: 12,
          column: 33
        }
      },
      "1": {
        start: {
          line: 14,
          column: 17
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "2": {
        start: {
          line: 15,
          column: 16
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "3": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "4": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 33
        }
      },
      "5": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 27
        }
      },
      "6": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 29,
          column: 35
        }
      },
      "7": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 94,
          column: 1
        }
      },
      "8": {
        start: {
          line: 34,
          column: 33
        },
        end: {
          line: 34,
          column: 60
        }
      },
      "9": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 41
        }
      },
      "10": {
        start: {
          line: 49,
          column: 26
        },
        end: {
          line: 49,
          column: 60
        }
      },
      "11": {
        start: {
          line: 50,
          column: 27
        },
        end: {
          line: 50,
          column: 61
        }
      },
      "12": {
        start: {
          line: 73,
          column: 52
        },
        end: {
          line: 90,
          column: 9
        }
      },
      "13": {
        start: {
          line: 97,
          column: 13
        },
        end: {
          line: 120,
          column: 1
        }
      },
      "14": {
        start: {
          line: 100,
          column: 2
        },
        end: {
          line: 104,
          column: 3
        }
      },
      "15": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 81
        }
      },
      "16": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 35
        }
      },
      "17": {
        start: {
          line: 106,
          column: 24
        },
        end: {
          line: 110,
          column: 7
        }
      },
      "18": {
        start: {
          line: 112,
          column: 2
        },
        end: {
          line: 119,
          column: 4
        }
      },
      "19": {
        start: {
          line: 122,
          column: 0
        },
        end: {
          line: 136,
          column: 2
        }
      },
      "20": {
        start: {
          line: 138,
          column: 0
        },
        end: {
          line: 145,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 17
          },
          end: {
            line: 14,
            column: 18
          }
        },
        loc: {
          start: {
            line: 14,
            column: 25
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 34,
            column: 15
          },
          end: {
            line: 34,
            column: 16
          }
        },
        loc: {
          start: {
            line: 34,
            column: 33
          },
          end: {
            line: 34,
            column: 60
          }
        },
        line: 34
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 46,
            column: 15
          },
          end: {
            line: 46,
            column: 16
          }
        },
        loc: {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 48,
            column: 41
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 49,
            column: 15
          },
          end: {
            line: 49,
            column: 16
          }
        },
        loc: {
          start: {
            line: 49,
            column: 26
          },
          end: {
            line: 49,
            column: 60
          }
        },
        line: 49
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 17
          }
        },
        loc: {
          start: {
            line: 50,
            column: 27
          },
          end: {
            line: 50,
            column: 61
          }
        },
        line: 50
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        },
        loc: {
          start: {
            line: 73,
            column: 52
          },
          end: {
            line: 90,
            column: 9
          }
        },
        line: 73
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 97,
            column: 13
          },
          end: {
            line: 97,
            column: 14
          }
        },
        loc: {
          start: {
            line: 97,
            column: 37
          },
          end: {
            line: 120,
            column: 1
          }
        },
        line: 97
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 27,
            column: 3
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 29,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 29,
            column: 17
          }
        }, {
          start: {
            line: 29,
            column: 21
          },
          end: {
            line: 29,
            column: 34
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 48,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 48,
            column: 23
          }
        }, {
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 48,
            column: 41
          }
        }],
        line: 48
      },
      "3": {
        loc: {
          start: {
            line: 49,
            column: 26
          },
          end: {
            line: 49,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 26
          },
          end: {
            line: 49,
            column: 36
          }
        }, {
          start: {
            line: 49,
            column: 40
          },
          end: {
            line: 49,
            column: 60
          }
        }],
        line: 49
      },
      "4": {
        loc: {
          start: {
            line: 50,
            column: 27
          },
          end: {
            line: 50,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 27
          },
          end: {
            line: 50,
            column: 37
          }
        }, {
          start: {
            line: 50,
            column: 41
          },
          end: {
            line: 50,
            column: 61
          }
        }],
        line: 50
      },
      "5": {
        loc: {
          start: {
            line: 73,
            column: 18
          },
          end: {
            line: 73,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 73,
            column: 37
          },
          end: {
            line: 73,
            column: 39
          }
        }],
        line: 73
      },
      "6": {
        loc: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        }, {
          start: {
            line: 102,
            column: 9
          },
          end: {
            line: 104,
            column: 3
          }
        }],
        line: 100
      },
      "7": {
        loc: {
          start: {
            line: 106,
            column: 24
          },
          end: {
            line: 110,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 107,
            column: 8
          }
        }, {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 110,
            column: 7
          }
        }],
        line: 106
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5b0ce4958c26b78db2ea2d74d824d5e5fd821e64"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_224iz9o3ou = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_224iz9o3ou();
var _ref = (cov_224iz9o3ou().s[0]++, _stylingConstants.default),
  font = _ref.font;
cov_224iz9o3ou().s[1]++;
var fontSize = function fontSize(size) {
  cov_224iz9o3ou().f[0]++;
  var sizes = (cov_224iz9o3ou().s[2]++, {
    small: font.sizeL,
    default: font.sizeXl,
    large: font.sizeXxl,
    xlarge: font.sizeXxxxl
  });
  var iconSize;
  cov_224iz9o3ou().s[3]++;
  if (Number(size)) {
    cov_224iz9o3ou().b[0][0]++;
    cov_224iz9o3ou().s[4]++;
    iconSize = "".concat(size / 16, "rem");
  } else {
    cov_224iz9o3ou().b[0][1]++;
    cov_224iz9o3ou().s[5]++;
    iconSize = sizes[size];
  }
  cov_224iz9o3ou().s[6]++;
  return (cov_224iz9o3ou().b[1][0]++, iconSize) || (cov_224iz9o3ou().b[1][1]++, sizes.default);
};
var IconWrapper = (cov_224iz9o3ou().s[7]++, (0, _utils.withThemedStyles)(_styledComponents.default.span.attrs({
  className: function className(_ref2) {
    var iconName = _ref2.iconName;
    cov_224iz9o3ou().f[1]++;
    cov_224iz9o3ou().s[8]++;
    return "g-Icon g-Icon-".concat(iconName);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      box-sizing: border-box;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      vertical-align: middle;\n      stroke: none;\n\n      color: ", ";\n      width: ", ";\n      height: ", ";\n\n      transform: translate3d(0, 0, 0);\n\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n\n      & > svg {\n        pointer-events: none;\n        display: block;\n        width: 100%;\n        height: 100%;\n        fill: currentColor;\n      }\n    "])), function (props) {
  cov_224iz9o3ou().f[2]++;
  cov_224iz9o3ou().s[9]++;
  return (
    // first get the color passed, if no color, use the currentColor value
    (cov_224iz9o3ou().b[2][0]++, props.iconColor) || (cov_224iz9o3ou().b[2][1]++, 'currentColor')
  );
}, function (props) {
  cov_224iz9o3ou().f[3]++;
  cov_224iz9o3ou().s[10]++;
  return (cov_224iz9o3ou().b[3][0]++, props.size) && (cov_224iz9o3ou().b[3][1]++, fontSize(props.size));
}, function (props) {
  cov_224iz9o3ou().f[4]++;
  cov_224iz9o3ou().s[11]++;
  return (cov_224iz9o3ou().b[4][0]++, props.size) && (cov_224iz9o3ou().b[4][1]++, fontSize(props.size));
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      box-sizing: border-box;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      vertical-align: middle;\n      stroke: none;\n      ", ";\n      }\n    "])), function (_ref3) {
  var _ref3$theme = _ref3.theme,
    _ref3$theme2 = _ref3$theme === void 0 ? (cov_224iz9o3ou().b[5][0]++, {}) : _ref3$theme,
    iconFontSize = _ref3$theme2.iconFontSize,
    size = _ref3.size;
  cov_224iz9o3ou().f[5]++;
  cov_224iz9o3ou().s[12]++;
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n\n        color: var(--textColor, currentColor);\n        width: 16px;\n        height: 16px;\n\n        transform: translate3d(0, 0, 0);\n\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n\n        & > svg {\n            width: 16px;\n            height: 16px;\n            pointer-events: none;\n            display: block;\n            fill: currentColor;\n        "])));
}))));

/** Component that load svg path and display it. */
cov_224iz9o3ou().s[13]++;
var Icon = function Icon(_ref4) {
  var size = _ref4.size,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  cov_224iz9o3ou().f[6]++;
  var svg;
  // STX-99764: Handle special case for language flag icon
  cov_224iz9o3ou().s[14]++;
  if (props.iconName.includes('lang_')) {
    cov_224iz9o3ou().b[6][0]++;
    cov_224iz9o3ou().s[15]++;
    svg = _icons.default.languageFlag[props.iconName.slice(props.iconName.length - 2)]; // 2 is the length of language code
  } else {
    cov_224iz9o3ou().b[6][1]++;
    cov_224iz9o3ou().s[16]++;
    svg = _icons.default[props.iconName];
  }
  var ariaAttribute = (cov_224iz9o3ou().s[17]++, !props.alt ? (cov_224iz9o3ou().b[7][0]++, {}) : (cov_224iz9o3ou().b[7][1]++, {
    'aria-label': props.alt
  }));
  cov_224iz9o3ou().s[18]++;
  return /*#__PURE__*/_react.default.createElement(IconWrapper, (0, _extends2.default)({
    size: size
  }, ariaAttribute, props, {
    dangerouslySetInnerHTML: {
      __html: svg
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 5
    }
  }));
};
cov_224iz9o3ou().s[19]++;
Icon.propTypes = {
  /** The name of the icone you want to use. It is the name of the svg file in the icons folder
  [cart, checkmark, chevron-down, chevron-left, chevron-right, chevron-up, close, credit-card, error-outline, error, hourglass, info-outline,
  menu, more, photot, sentiment-dissatisfied, sentiment-very-dissatisfied, shopping-basket, grade] */
  iconName: _propTypes.default.string.isRequired,
  /** May contains a number or one of small, default, large, xlarge */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** It defines the color that will be applied to the icon, if no pass it take the theme color for the icon */
  iconColor: _propTypes.default.string,
  /* Alt content of icon - Use for accessibility */
  alt: _propTypes.default.string,
  /** theme context */
  currentTheme: _propTypes.default.string,
  theme: _propTypes.default.shape({})
};
cov_224iz9o3ou().s[20]++;
Icon.defaultProps = {
  size: 'small',
  iconColor: undefined,
  alt: undefined,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme,
  theme: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _styledComponents.withTheme)(Icon)));